import { AxiosResponse } from "axios";

/**
 * Validates if a string parameter is not undefined, null, or empty (after trimming)
 * @param str The string to validate
 * @returns True if the string is valid, false otherwise
 */
export function isValidString(str?: string): boolean {
  return str !== undefined && str !== null && str.trim() !== "";
}

/**
 * Validates if a number parameter is not undefined, null, or NaN
 * @param num The number to validate
 * @returns True if the number is valid, false otherwise
 */
export function isValidNumber(num?: number): boolean {
  return num !== undefined && num !== null && !isNaN(num);
}

/**
 * Validates if a boolean parameter is not undefined or null
 * @param bool The boolean to validate
 * @returns True if the boolean is valid, false otherwise
 */
export function isValidBoolean(bool?: boolean): boolean {
  return bool !== undefined && bool !== null;
}
export function isResponseValid(response: AxiosResponse<any, any>): boolean {
  // If response is null or data is null, show error
  if (response == null || response.data == null) {
    return false;
  }
  // Check response code
  const responseCode = response.data.responseMessage?.code;
  if (responseCode === 1 || responseCode === 2) {
    return true;
  } else {
    return false;
  }
}
